import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
const externalScriptId = 'google-analytics-script';
const bootstrapScriptId = 'google-analytics-bootstrap';

function loadGoogleAnalytics() {
  if (!measurementId || typeof document === 'undefined') {
    return;
  }

  if (!document.getElementById(externalScriptId)) {
    const script = document.createElement('script');
    script.id = externalScriptId;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);
  }

  if (!document.getElementById(bootstrapScriptId)) {
    const bootstrap = document.createElement('script');
    bootstrap.id = bootstrapScriptId;
    bootstrap.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      window.gtag = window.gtag || gtag;
      gtag('js', new Date());
      gtag('config', '${measurementId}', { send_page_view: false });
    `;
    document.head.appendChild(bootstrap);
  }
}

function trackPageView(pagePath) {
  if (!measurementId || typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', 'page_view', {
    page_location: window.location.href,
    page_path: pagePath,
    page_title: document.title,
    send_to: measurementId
  });
}

export default function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    loadGoogleAnalytics();
  }, []);

  useEffect(() => {
    if (!measurementId) {
      return;
    }

    const pagePath = `${location.pathname}${location.search}${location.hash}`;
    trackPageView(pagePath);
  }, [location.hash, location.pathname, location.search]);

  return null;
}
